import dsf from "../utils";

import * as mixins from "../mixins";

//dsf母体
!(function () {
  if (!dsf.global.$mixins) {
    dsf.global.$mixins = {};
  }
  for (let k in mixins) {
    dsf.global.$mixins[k] = mixins[k];
  }
})();
